import { PageTypeAdmin, PageTypePortal } from "@/lib/types";

/**
 * Routes where signed-in portal dashboards render (admin, teacher, staff, member).
 * Public marketing/auth pages and global routes are excluded.
 */
export function isDashboardAppRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return false;

  return (
    pathname === PageTypeAdmin.Dashboard ||
    pathname.startsWith(`${PageTypeAdmin.Dashboard}/`) ||
    pathname === PageTypePortal.Dashboard ||
    pathname.startsWith(`${PageTypePortal.Dashboard}/`)
  );
}

/** Admin auth entry (sign-in, password reset) - shares dashboard appearance when classic is active. */
export function isAdminAuthRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return false;

  return (
    pathname === PageTypeAdmin.SignIn ||
    pathname === PageTypeAdmin.ForgotPassword ||
    pathname === PageTypeAdmin.ResetPassword ||
    pathname.startsWith(`${PageTypeAdmin.SignIn}/`)
  );
}

/**
 * Routes where tenant dashboard appearance (modern/classic) applies.
 */
export function isDashboardAppearanceRoute(
  pathname: string | null | undefined,
): boolean {
  return isDashboardAppRoute(pathname) || isAdminAuthRoute(pathname);
}

export type ThemeScope = "public" | "dashboard";

export function getThemeScope(pathname: string | null | undefined): ThemeScope {
  return isDashboardAppRoute(pathname) ? "dashboard" : "public";
}
